import { IParamValues } from '../Components/BokforderContext/BokforderContextManager';

export const parseParamsValues = (paramValues: string): IParamValues => {
  const params: IParamValues = paramValues
    ?.split(';')
    .reduce((prev, param: string) => {
      if (param === '') {
        return prev;
      }
      const split = param.split('=');
      return { ...prev, [split[0]]: split[1] ?? null };
    }, {});
  return params;
};
